import { useEffect } from "react";
import AOS from "aos";

const SolarFinancingFeatures = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
        });
    }, []);

    return (
        <section className="solar-financing-features">
            <div className="about-us" >
                <div className="first" data-aos="fade-right">
                    <div className="column">
                        <h1>Key Benefits and Features</h1>
                        <ul className="features">
                            <li>Up to ₦6 million for salary earners & households.</li>
                            <li>Up to ₦100 million for businesses.</li>
                            <li>Pay 30% (as low as ₦300k)</li>
                            <li>Spread balance up to 24 months.</li>
                            <li>Up to 4% interest rate.</li>
                            <li>Liquidate at any time.</li>
                            <li>Enjoy solar while still paying.</li>
                        </ul>
                        <a
                            href="https://wa.me/2349166416423?text=You%20offer%20solar%20financing%3F%20Please%20tell%20me%20more"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="btn btn-small">Chat With Us</button>
                        </a>
                    </div>
                    <div className="about-us-img">
                        <img src={`${process.env.PUBLIC_URL}/assets/img/benefit-and-features.png`} alt="img" />

                    </div>
                </div>

                <div className="second" data-aos="fade-right">
                    <div className="column">
                        <h1>How it works</h1>
                        <ul className="features">
                            <li>Contact a solar installer to check your energy needs.</li>
                            <li>If you don’t have one, we can assign you to one of our trusted vendors.</li>
                            <li>Get a quotation/invoice.</li>
                            <li>Submit along with our form.</li>
                            <li>We assess your eligibility.</li>
                            <li>You pay 30% equity contribution.</li>
                            <li>We disburse funds and oversee installation.</li>
                        </ul>

                        <a
                            href="https://wa.me/2349166416423?text=You%20offer%20solar%20financing%3F%20Please%20tell%20me%20more"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="btn btn-small">Chat With Us</button>
                        </a>
                    </div>
                    <div className="about-us-img">
                        <img className="float-right" src={`${process.env.PUBLIC_URL}/assets/img/how-it-works.png`} alt="img" />

                    </div>
                </div>


            </div>
        </section>
    );
};

export default SolarFinancingFeatures;
